module.exports = __webpack_public_path__ + "static/media/AIG.225e870f.svg";